import React, { useEffect } from 'react';
import { usePrefs } from 'wsm-common-data';
import './Widget.scss';
import { setNewRelicCustomAttribute } from 'ddc-new-relic';
import GalleryContainer from '../components/gallery/GalleryContainer';

const WidgetContainer = () => {
	// TODO: Remove after confirming legacy values of galleryToolbarPlacement: top-right/bottom-right are changed to top/bottom values
	const { galleryToolbarPlacement } = usePrefs();
	useEffect(() => {
		setNewRelicCustomAttribute(
			'galleryToolbarPlacement',
			galleryToolbarPlacement
		);
	}, [galleryToolbarPlacement]);
	return <GalleryContainer />;
};

export default WidgetContainer;
